export default __webpack_public_path__ + "static/media/person.60b8e6b1.svg";